export const NPS_SURVEY_SOURCE = {
  cancelChat: 'cancel_chat',
  planChange: 'plan-change',
  saveOffer: 'save_offer',
  selfCancel: 'self_cancel',
};

export const isPlanChange = source => source === NPS_SURVEY_SOURCE.saveOffer || source === NPS_SURVEY_SOURCE.planChange;
